import { Button, Dialog, Flex } from '@servicetitan/anvil2';
import styles from './SimpleConfirmationModal.module.css';

export interface SimpleConfirmationModalProps {
  title?: string;
  body?: string;
  isOpen: boolean;
  primaryText?: string;
  secondaryText?: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  onClose?: () => void;
}

const SimpleConfirmationModal = ({
  title,
  isOpen,
  body,
  primaryText,
  secondaryText,
  onPrimaryClick,
  onSecondaryClick,
  onClose,
}: SimpleConfirmationModalProps) => {
  return (
    <Dialog
      open={isOpen}
      data-testid='confirmation-modal'
      className={styles.dialogContainer}
      onClose={onClose}
    >
      {title && <Dialog.Header>{title}</Dialog.Header>}
      <Dialog.Content>{body}</Dialog.Content>
      <Dialog.Footer>
        <Flex gap='3' justifyContent='flex-end'>
          <Dialog.CancelButton onClick={onSecondaryClick}>
            {secondaryText}
          </Dialog.CancelButton>
          <Button appearance='danger' onClick={onPrimaryClick}>
            {primaryText}
          </Button>
        </Flex>
      </Dialog.Footer>
    </Dialog>
  );
};

export default SimpleConfirmationModal;
